import { getApiBaseUrl } from '../utils/apiBaseUrl';

export interface DeleteUserAsync {
  message: string;
}

export const deleteUserAdmin = async (
  id: number,
  token: string
): Promise<DeleteUserAsync> => {
  const baseUrl = getApiBaseUrl();

  const response = await fetch(`${baseUrl}/api/Admin/DeleteUserAsync/${id}`, {
    method: "DELETE",
  headers: {
    Authorization: `Bearer ${token}`,
    
  },
  
  });

  if (!response.ok) {
    throw new Error(`Failed to delete user: ${response.status}`);
  }

  const data: DeleteUserAsync = await response.json();
  return data;
};